const CORRECT_PHONE_LENGTH = 12; // +79991234567

export function clearPhone(str) {
    let phone = str.trim();
    phone = phone.split(" ").join("");

    phone = phone.replace(/[(-)]/g, "");

    return phone;
}

export function isPhoneValid(str) {
    const phone = clearPhone(str);
    return phone.length === CORRECT_PHONE_LENGTH;
}
